(ns hai.library.tables.routes
  (:require
   [hai.ui.components :as c]
   [hai.ui.icons :as icons]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Connected Tables 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/tables"
    {:name :tables
     ::routing/window-title "Tables"
     :label "Manage Tables"
     :icon icons/outlined-backup_table
     :view page}]])
